import React from "react";
import styles from "./SubmissionSuccess.module.scss";

export const SubmissionSuccess = ({ message }) => (
  <div className={styles.successBanner}>
    <div>{message}</div>
  </div>
);
